import axios from 'axios';
import React, { useState } from 'react';

const LoginPage = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault(); // 폼 기본 제출 방지

    // 간단한 유효성 검사 (실제 앱에서는 서버 통신 로직 추가)
    if (!id || !password) {
      setError('id와 비밀번호를 모두 입력해주세요.');
      return;
    }

    setError('');

    axios.post('/api/manage/login', {username: id, password: password}, {timeout: process.env.REACT_APP_API_TIMEOUT})
        .then((res) => {
          sessionStorage.setItem('login', 'true');
          window.location.href = '/';
        })
        .catch((err) => {
            window.location.href = '/login';
            console.log(err);
        })
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh', // 뷰포트 전체 높이
      backgroundColor: '#f0f2f5', // 배경색
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: '40px',
        borderRadius: '8px',
        width: '100%',
        maxWidth: '400px', // PC에 맞는 적당한 너비
        boxSizing: 'border-box'
      }}>
        <h2 style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#333'
        }}>
          로그인
        </h2>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="id" style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold',
              color: '#555'
            }}>
              id
            </label>
            <input
              type="text"
              id="id"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="id를 입력하세요"
              style={{
                width: 'calc(100% - 20px)',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em'
              }}
              required
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="password" style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold',
              color: '#555'
            }}>
              비밀번호:
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력하세요"
              style={{
                width: 'calc(100% - 20px)',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em'
              }}
              required
            />
          </div>

          {error && <p style={{ color: 'red', textAlign: 'center', marginBottom: '15px' }}>{error}</p>}

          <button type="submit" style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '1.1em',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease'
          }}>
            로그인
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;